module.exports = __webpack_public_path__ + "img/lock.648401a3.png";